export default {
  sm: `
  Goal of 
  DATA CENTER GAK
  `,
  lg: `
  Goal of DATA CENTER GAK
  `,
};
